import { render } from "./CsatThankYou.vue?vue&type=template&id=61e8c3ae"
import script from "./CsatThankYou.vue?vue&type=script&lang=js"
export * from "./CsatThankYou.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__